import React, { FC } from "react"
import { connect } from "react-redux"
import AppUICard from "../cards/AppUICard"
import ArtistCard from "../cards/ArtistCard"
import MultiCard from "../cards/MultiCard"
import { RootState } from "../../store/reducers"
import { Playlist } from "../../models/playlist"
import { Track } from "../../models/track"
import { User } from "../../models/user"

const Featured: FC<{
  list: Track[]
  users: User[]
  playlists: Playlist[]
  tags?: string[]
}> = ({ list, playlists, users }) => {
  document.getElementsByTagName("title")[0].innerHTML = "featured"

  return (
    <div className="app-view">
      <div className="app-view-body" id="featured">
        <div className="featured-item">
          <h4 className="app-text">Artists</h4>
          <div id="discover-artists">
            {users &&
              users.map((user) => <ArtistCard user={user} key={user.id} />)}
          </div>
        </div>
        <div className="featured-item">
          <h4 className="app-text">Albums</h4>
          {/* <div id="album-render" className="tracks-grid"> */}
          <div id="playlist-render">
            {playlists &&
              playlists.map((playlist, i) => (
                <MultiCard key={i} playlist={playlist} />
              ))}
          </div>
        </div>
      </div>
      <div className="app-view-extra ls">
        <div className="extras-body">
          <div>
            <div className="artist">
              <div
                className="artist-name"
                style={{ fontSize: "24px", marginBottom: "8px" }}
              >
                Featured
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {list && list.map((a, i) => <AppUICard track={a} key={i} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  list: state.data.list,
  users: state.data.users,
  playlists: state.data.playlists,
})

export default connect(mapStateToProps)(Featured)
